import React from 'react';
import { useSelector } from 'react-redux';
import { styled } from '@mui/system';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { GUESTS_STATUS_CHECKOUT_INFO } from 'bento-ordering/group_ordering/constants/groupOrder';
import { getAdminAndGuestDiners } from 'bento-ordering/cart/selectors/index';

const StyleStatusInfo = styled(Typography)(({ theme }) => ({
  marginTop: '8px',
  fontSize: '14px',
  color: theme.palette.mediumSoy,
  fontFamily: theme.typography.fontFamily,
  fontWeight: '450',
  textAlign: 'center'
}));

const GuestsStatusCheckoutInfo = () => {
  const { guestDiners } = useSelector(getAdminAndGuestDiners);

  const getDinersStatus = () => {
    let status = '';

    if (!guestDiners.length) {
      status = GUESTS_STATUS_CHECKOUT_INFO.noGuestHaveJoined;
    } else {
      const hasAllGuestsConfirmedTheirOrder = guestDiners.every(
        guest => guest.done_ordering
      );

      if (hasAllGuestsConfirmedTheirOrder) {
        status = GUESTS_STATUS_CHECKOUT_INFO.allGuestsHaveConfirmed;
      } else {
        status = GUESTS_STATUS_CHECKOUT_INFO.notAllGuestsHaveConfirmed;
      }
    }

    return status;
  };

  return (
    <Box display="flex" justifyContent="center">
      <StyleStatusInfo>{getDinersStatus()}</StyleStatusInfo>
    </Box>
  );
};

export default GuestsStatusCheckoutInfo;
